export enum MaterialFormTab {
  MaterialInfo = 'materialInfo',
  CostsSelection = 'costsSelection',
  CostsOrder = 'costsOrder',
  CostsUsage = 'costsUsage',
}
